import { Box, makeStyles } from '@material-ui/core';
import { connect, ConnectedProps } from 'react-redux';
// Data Layer
import {
  CoverageCatalog,
  CoverageCatalogResume,
  Quotation,
  QuotationUnit,
} from 'data-layer-cr/dist/models';
// Redux
import { RootState } from 'src/store/rootReducer';
// Components
import { orderCoverageCatalog } from 'src/functions/coverageMethods';
import { isPremiumOption } from 'src/functions/individualOptionHelpers';
import CreatedQuotationResumeCard from '../InformationCards/CreatedQuotationResumeCard';

const useStyles = makeStyles(() => ({
  cardRoot: {
    position: 'relative',
    minWidth: 275,
    borderRadius: 10,
    boxShadow: '0px 2px 15px rgba(0, 0, 0, 0.08)',
    overflow: 'hidden',
  },
  triangle: {
    position: 'absolute',
    borderTop: '48.45px solid #E37E07',
    borderRight: '55.45px solid transparent',
  },
  star: {
    position: 'absolute',
    top: '5px',
    left: '4px',
  },
}));

export const UnitSelectionItem = ({
  quotation,
  coverageCatalogs,
  coverageCatalogResumes,
  unit,
  packageOption,
  onSelected,
  forceCollapsed,
  onForceCollapsedUpdate,
}: Props): JSX.Element => {
  const premiumOption = isPremiumOption(packageOption);
  const classes = useStyles();
  return (
    <Box className={classes.cardRoot}>
      {premiumOption && (
        <>
          <Box className={classes.triangle} />
          <img
            data-testid="premium-star-icon"
            src="svg/premium_start.svg"
            alt="premium star"
            className={classes.star}
          />
        </>
      )}
      <CreatedQuotationResumeCard
        data-testid="individual-unit-resume-card"
        coverageCatalogs={coverageCatalogs}
        coverageCatalogResumes={coverageCatalogResumes}
        unit={unit}
        moneyType={quotation.quotationProfile.typeOfMoney}
        packageOption={packageOption}
        quotation={quotation}
        forceCollapsed={forceCollapsed}
        onForceCollapsedUpdate={onForceCollapsedUpdate}
        onSelected={onSelected}
      />
    </Box>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  quotation: Quotation;
  coverageCatalogs: CoverageCatalog[];
  coverageCatalogResumes: CoverageCatalogResume[];
} => ({
  quotation: state.quotation.quotation,
  coverageCatalogs: orderCoverageCatalog(
    state.coverageCatalog.coverageCatalogs,
  ),
  coverageCatalogResumes: state.coverageCatalog.coverageCatalogResumes,
});

const connector = connect(mapStateToProps, {});
type PropsFromRedux = ConnectedProps<typeof connector>;

interface Props extends PropsFromRedux {
  unit: QuotationUnit;
  packageOption: number;
  onSelected: (packageId: number, forceNext: boolean) => void;
  forceCollapsed?: boolean;
  onForceCollapsedUpdate?: () => void;
}

export default connector(UnitSelectionItem);
